import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import ScrollingBanner from "@/components/layout/ScrollingBanner";
import ChatWidget from "@/components/chat/ChatWidget";

const PublicLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col paper-bg">
      {/* WCAG 2.4.1 — Bypass blocks: skip directly to page content */}
      <a href="#main-content" className="skip-link" data-testid="skip-to-content">
        Skip to main content
      </a>
      <ScrollingBanner />
      <Header />
      <main id="main-content" tabIndex={-1} className="flex-1" data-testid="page-main">
        {children}
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
};

export default PublicLayout;
